// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-buttons-container {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 100%;
  grid-auto-flow: row;
  grid-auto-rows: min-content;
  justify-content: center;
  align-items: start;
}
.auth-buttons-container .info-text-container {
  display: grid;
  grid-template-columns: 100%;
  grid-auto-flow: row;
  grid-auto-rows: min-content;
  row-gap: 15px;
  padding-bottom: 75px;
}
.auth-buttons-container .info-text-container .title-container .title {
  margin: 0;
  font-size: var(--font-size-extra-large);
  font-weight: var(--font-weight-regular);
  color: var(--mi-grey-color-13);
  text-align: left;
}
.auth-buttons-container .info-text-container .title-container .title span {
  font-weight: var(--font-weight-bold);
}
.auth-buttons-container .info-text-container .subtitle-container .subtitle {
  margin: 0;
  font-size: var(--font-size-large);
  font-weight: var(--font-weight-regular);
  color: var(--mi-grey-color-16);
  text-align: left;
}
.auth-buttons-container .buttons-container {
  display: grid;
  grid-template-columns: 100%;
  grid-auto-flow: row;
  grid-auto-rows: min-content;
  row-gap: 20px;
  justify-content: center;
}
.auth-buttons-container .buttons-container .auth-button {
  height: 63px;
}
.auth-buttons-container .buttons-container .button-separator-container p {
  margin: 0;
  font-size: var(--font-size-large);
  font-weight: var(--font-weight-semi-bold);
  color: var(--mi-secondary-color-2);
  text-align: center;
}
.auth-buttons-container .buttons-container .sign-in {
  --background: var(--mi-blue-color-4);
  --color: var(--mi-grey-color-13);
  --border-color: var(--mi-blue-color-4);
  --background-hover: var(--mi-blue-color-10);
}
.auth-buttons-container .buttons-container .sign-in:hover {
  --border-color: var(--mi-blue-color-10);
  --color-hover: var(--mi-grey-color-13);
}
.auth-buttons-container .help-center-link-container {
  padding-top: 13px;
}
.auth-buttons-container .help-center-link-container p {
  margin: 0;
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-regular);
  color: var(--mi-primary-color);
  text-align: center;
  cursor: pointer;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
